var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem13A(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      enableBackground: "new 0 0 750 289"
    },
    viewBox: "0 0 750 289",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M750 0H0v289.4h750V0z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.3 37.6c.4-3.9 2.5-6 6.4-6.4h-36.9c3.8.4 5.8 2.5 6.2 6.4v176.8c.7 7.5 4.8 11.5 12.2 12.2 7.3-.7 11.3-4.8 12.1-12.2V37.6z",
    style: {
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M562.7 32.1v-1.9c-4.5.4-7 2.9-7.3 7.3v176.8c-.1 3.3-1.1 6-3.2 8.1-2.2 2-4.8 3.1-7.9 3.2-3.3-.1-6-1.2-8.1-3.2-2-2.1-3.1-4.8-3.2-8.1V37.6c-.4-4.5-2.8-6.9-7.2-7.3v1.9c3.1.3 4.9 2.1 5.3 5.5v176.8c.7 8 5.1 12.4 13.2 13.2 7.9-.8 12.2-5.1 13-13.2V37.6c.3-3.3 2.1-5.2 5.4-5.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M552.9 103.2h-17.3l-3.6 3.6v107.5c.7 7.5 4.8 11.5 12.2 12.2 7.3-.7 11.4-4.8 12.1-12.2V106.7l-3.4-3.5z",
    style: {
      fill: "#fff"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m557.2 106.4-4-4.1h-18.1l-.4.2-3.2 3.4h-.5v108.5c.7 8 5.1 12.4 13.2 13.2 7.9-.8 12.2-5.1 13-13.2v-108m-4.7-2.2 2.8 3v107.2c0 3.3-1.1 6-3.2 8.1-2.2 2-4.8 3.1-7.9 3.2-3.3-.1-6-1.2-8.1-3.2-2-2.1-3.1-4.8-3.2-8.1v-107l2.8-3.2h16.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M542.6 202.6c-.2-2.1-1.3-3.2-3.4-3.4-2.1.2-3.2 1.3-3.4 3.4.2 2.1 1.3 3.2 3.4 3.4 2.1-.2 3.2-1.3 3.4-3.4z",
    style: {
      fill: "#fff"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M539.2 198.6c-2.4.3-3.8 1.6-4 4.1.2 2.4 1.5 3.8 4 4 2.4-.2 3.8-1.5 4-4-.3-2.5-1.6-3.8-4-4.1m-2.7 4.1c.1-1.7 1-2.6 2.6-2.8 1.6.2 2.5 1.1 2.6 2.8-.1 1.6-1 2.5-2.6 2.6-1.6 0-2.5-.9-2.6-2.6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M542.6 191.8c-.2-2.1-1.3-3.2-3.4-3.4-2.1.2-3.2 1.3-3.4 3.4.2 2.1 1.3 3.2 3.4 3.4 2.1-.2 3.2-1.3 3.4-3.4z",
    style: {
      fill: "#fff"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M539.2 187.8c-2.4.2-3.8 1.5-4 4 .2 2.5 1.5 3.9 4 4.1 2.4-.3 3.8-1.6 4-4.1-.3-2.5-1.6-3.8-4-4m-2.7 4c.1-1.6 1-2.5 2.6-2.6 1.6.1 2.5 1 2.6 2.6-.1 1.7-1 2.6-2.6 2.8-1.6-.2-2.5-1.2-2.6-2.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M550.9 179.7c-.2-2.1-1.3-3.2-3.4-3.4-1.9.2-3 1.3-3.2 3.4.3 1.9 1.3 3 3.2 3.2 2.1-.3 3.3-1.3 3.4-3.2z",
    style: {
      fill: "#fff"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M547.7 175.4c-2.3.3-3.6 1.6-4 4.1.3 2.4 1.6 3.7 4 4 2.5-.3 3.9-1.6 4.1-4-.3-2.5-1.6-3.8-4.1-4.1m-2.7 4.1c.1-1.7 1-2.6 2.6-2.8 1.7.2 2.6 1.1 2.8 2.8-.2 1.6-1.1 2.4-2.8 2.6-1.6-.1-2.5-1-2.6-2.6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M552.9 162.7c-.2-2.1-1.3-3.2-3.4-3.4-2.1.2-3.2 1.3-3.4 3.4.2 1.9 1.3 3 3.4 3.2 2.1-.1 3.2-1.2 3.4-3.2z",
    style: {
      fill: "#fff"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M549.5 158.6c-2.4.3-3.8 1.6-4 4.1.2 2.4 1.5 3.7 4 4 2.4-.3 3.8-1.6 4-4-.2-2.5-1.5-3.8-4-4.1m-2.6 4.1c.1-1.7 1-2.6 2.6-2.8 1.6.2 2.5 1.1 2.6 2.8-.1 1.5-1 2.4-2.6 2.6-1.6-.2-2.5-1.1-2.6-2.6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M543.3 143.3c-.2-2.1-1.3-3.2-3.4-3.4-2.1.2-3.2 1.3-3.4 3.4.2 2.1 1.3 3.2 3.4 3.4 2.1-.2 3.2-1.3 3.4-3.4z",
    style: {
      fill: "#fff"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M539.8 139.4c-2.3.2-3.6 1.5-4 4 .3 2.4 1.6 3.8 4 4 2.5-.2 3.9-1.5 4.1-4-.2-2.4-1.6-3.8-4.1-4m-2.6 4c.1-1.6 1-2.5 2.6-2.6 1.7.1 2.6 1 2.8 2.6-.2 1.6-1.1 2.5-2.8 2.6-1.6-.1-2.5-1-2.6-2.6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M551.5 118.4c-.2-2.1-1.3-3.2-3.4-3.4-2.1.2-3.2 1.3-3.4 3.4.2 2.1 1.3 3.2 3.4 3.4 2.1-.2 3.2-1.3 3.4-3.4z",
    style: {
      fill: "#fff"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M548.2 114.3c-2.4.2-3.8 1.5-4 4 .2 2.5 1.5 3.9 4 4.1 2.4-.3 3.8-1.6 4-4.1-.3-2.4-1.6-3.8-4-4m-2.7 4c.1-1.6 1-2.5 2.6-2.6 1.6.1 2.5 1 2.6 2.6-.1 1.6-1 2.5-2.6 2.8-1.6-.3-2.5-1.2-2.6-2.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M551.5 211.1c-.2-2.1-1.3-3.2-3.4-3.4-2.1.2-3.2 1.3-3.4 3.4.2 2.1 1.3 3.2 3.4 3.4 2.1-.2 3.2-1.3 3.4-3.4z",
    style: {
      fill: "#fff"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M548.2 207.2c-2.4.2-3.8 1.5-4 4 .2 2.4 1.5 3.8 4 4 2.4-.2 3.8-1.5 4-4-.3-2.4-1.6-3.8-4-4m-2.7 4c.1-1.6 1-2.5 2.6-2.6 1.6.1 2.5 1 2.6 2.6-.1 1.6-1 2.5-2.6 2.6-1.6-.1-2.5-1-2.6-2.6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M387.1 37.6c.4-3.9 2.5-6 6.4-6.4h-37.1c4 .4 6.1 2.5 6.4 6.4v176.8c.8 7.5 4.8 11.5 12.1 12.2 7.5-.7 11.6-4.8 12.2-12.2V37.6z",
    style: {
      fill: "#fff"
    }
  }), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M393.5 32.1v-1.9c-4.5.4-7 2.9-7.3 7.3v176.8c-.1 3.3-1.2 6-3.2 8.1-2.1 2-4.8 3.1-8.1 3.2-3.1-.1-5.7-1.2-7.9-3.2-2.1-2.1-3.1-4.8-3.2-8.1V37.6c-.4-4.5-2.9-6.9-7.3-7.3v1.9c3.3.3 5.1 2.1 5.5 5.5v176.8c.8 8 5.1 12.4 13 13.2 8.1-.8 12.5-5.1 13.2-13.2V37.6c.2-3.3 2-5.2 5.3-5.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M383.6 110.6h-17.3l-3.4-3.8v107.5c.7 7.5 4.7 11.5 12.1 12.2 7.5-.7 11.6-4.8 12.2-12.2V106.8l-3.6 3.8z",
    style: {
      fill: "#fff"
    }
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m388.1 104.6-4.7 5.1h-16.8l-3.2-3.4-.2-.4h-1.3v108.5c.8 8 5.1 12.4 13 13.2 8-.8 12.4-5.1 13.2-13.2V104.6m-3.8 6.8 1.9-2v105c-.1 3.3-1.2 6-3.2 8.1-2.1 2-4.8 3.1-8.1 3.2-3.1-.1-5.8-1.2-7.9-3.2-2.1-2.1-3.2-4.8-3.2-8.1v-105l2.1 2.2H384l.3-.2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M371.9 210.6c-.2-2.1-1.3-3.2-3.2-3.4-2.1.2-3.2 1.3-3.4 3.4.2 2.1 1.3 3.2 3.4 3.4 2-.2 3.1-1.3 3.2-3.4z",
    style: {
      fill: "#fff"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M368.7 206.6c-2.5.2-3.9 1.5-4.1 4 .3 2.4 1.6 3.8 4.1 4 2.3-.2 3.6-1.5 4-4-.4-2.4-1.7-3.8-4-4m-2.8 4c.2-1.6 1.1-2.5 2.8-2.6 1.6.1 2.5 1 2.6 2.6-.1 1.6-1 2.5-2.6 2.6-1.7-.1-2.6-1-2.8-2.6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M380.1 195.7c-.2-2.1-1.3-3.2-3.4-3.4-1.9.2-3 1.3-3.2 3.4.3 2.1 1.3 3.2 3.2 3.4 2.1-.2 3.2-1.3 3.4-3.4z",
    style: {
      fill: "#fff"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M376.8 191.6c-2.3.3-3.6 1.6-4 4.1.3 2.4 1.6 3.8 4 4 2.5-.2 3.9-1.5 4.1-4-.2-2.5-1.6-3.9-4.1-4.1m-2.6 4.1c.3-1.6 1.1-2.5 2.6-2.8 1.7.3 2.6 1.3 2.8 2.8-.2 1.6-1.1 2.5-2.8 2.6-1.5-.1-2.4-1-2.6-2.6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M381.5 181.2c-.2-2.1-1.3-3.2-3.4-3.4-2.1.2-3.2 1.3-3.4 3.4.2 2.1 1.3 3.2 3.4 3.4 2.1-.2 3.2-1.3 3.4-3.4z",
    style: {
      fill: "#fff"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M378.1 177.2c-2.3.2-3.6 1.5-4 4 .3 2.4 1.6 3.8 4 4 2.5-.2 3.9-1.5 4.1-4-.2-2.5-1.6-3.8-4.1-4m-2.6 4c.1-1.6 1-2.5 2.6-2.6 1.7.1 2.6 1 2.8 2.6-.2 1.6-1.1 2.5-2.8 2.6-1.6-.1-2.5-1-2.6-2.6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M374.7 169.3c-.1-2.1-1.2-3.2-3.2-3.4-2.1.2-3.2 1.3-3.4 3.4.2 2.1 1.3 3.2 3.4 3.4 2-.2 3.1-1.3 3.2-3.4z",
    style: {
      fill: "#fff"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M371.5 165.4c-2.5.2-3.9 1.5-4.1 4 .3 2.4 1.6 3.8 4.1 4 2.3-.2 3.6-1.5 4-4-.4-2.5-1.7-3.8-4-4m-2.8 4c.2-1.6 1.1-2.5 2.8-2.6 1.6.1 2.5 1 2.6 2.6-.1 1.6-1 2.5-2.6 2.6-1.7-.1-2.6-1-2.8-2.6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M380.5 146.5c-.2-1.9-1.3-3-3.4-3.2-2.1.2-3.2 1.3-3.4 3.2.2 2.1 1.3 3.2 3.4 3.4 2.1-.2 3.2-1.3 3.4-3.4z",
    style: {
      fill: "#fff"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M377.2 142.4c-2.4.3-3.8 1.6-4 4 .2 2.5 1.5 3.9 4 4.1 2.4-.3 3.8-1.6 4-4.1-.2-2.4-1.5-3.7-4-4m-2.6 4c.1-1.5 1-2.4 2.6-2.6 1.6.3 2.5 1.1 2.6 2.6-.1 1.7-1 2.6-2.6 2.8-1.6-.2-2.5-1.2-2.6-2.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M376.8 123.9c-.3-2-1.3-3.1-3.2-3.2-2.1.1-3.2 1.2-3.4 3.2.2 2.1 1.3 3.2 3.4 3.4 1.9-.2 2.9-1.3 3.2-3.4z",
    style: {
      fill: "#fff"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M373.6 120c-2.5.3-3.9 1.6-4.1 4 .3 2.5 1.6 3.9 4.1 4.1 2.3-.3 3.6-1.6 4-4.1-.3-2.4-1.6-3.7-4-4m-2.8 4c.2-1.6 1.1-2.5 2.8-2.6 1.6.1 2.5 1 2.6 2.6-.1 1.7-1 2.6-2.6 2.8-1.7-.2-2.6-1.2-2.8-2.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M382 212.9c-.2-1.9-1.3-3-3.4-3.2-2.1.2-3.2 1.3-3.4 3.2.2 2.1 1.3 3.2 3.4 3.4 2.1-.2 3.2-1.4 3.4-3.4z",
    style: {
      fill: "#fff"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M378.7 208.9c-2.4.3-3.8 1.6-4 4 .2 2.5 1.5 3.9 4 4.1 2.4-.3 3.8-1.6 4-4.1-.2-2.4-1.5-3.7-4-4m-2.6 3.9c.1-1.6 1-2.4 2.6-2.6 1.6.2 2.5 1.1 2.6 2.6-.1 1.7-1 2.6-2.6 2.8-1.6-.2-2.5-1.1-2.6-2.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M218 37.6c.4-3.9 2.4-6 6.2-6.4h-36.9c3.9.4 6 2.5 6.4 6.4v176.8c.6 7.5 4.6 11.5 12.1 12.2 7.5-.7 11.6-4.8 12.2-12.2V37.6z",
    style: {
      fill: "#fff"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M224.2 32.1v-1.9c-4.4.4-6.8 2.9-7.2 7.3v176.8c-.1 3.3-1.3 6-3.4 8.1-1.9 2-4.6 3.1-7.9 3.2-3.1-.1-5.7-1.2-7.9-3.2-2.1-2.1-3.2-4.8-3.2-8.1V37.6c-.4-4.5-2.9-6.9-7.3-7.3v1.9c3.2.3 5 2.1 5.5 5.5v176.8c.8 8 5.1 12.4 13 13.2 8.1-.8 12.5-5.1 13.2-13.2V37.6c.3-3.3 2-5.2 5.2-5.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M217.9 106.8h-24.3v107.5c.6 7.5 4.6 11.5 12.1 12.2 7.5-.7 11.6-4.8 12.2-12.2V106.8z",
    style: {
      fill: "#fff"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M218.9 105.8h-26.2v108.5c.8 8.1 5.1 12.5 13 13.2 8.1-.7 12.5-5.1 13.2-13.2V105.8m-24.3 1.9H217v106.6c-.1 3.3-1.2 6-3.4 8.1-1.9 2-4.6 3.1-7.9 3.2-3.1-.1-5.7-1.2-7.9-3.2-2.1-2.1-3.1-4.8-3.2-8.1V107.7z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.6 207.2c-.2-1.9-1.3-3-3.4-3.2-2.1.2-3.2 1.3-3.4 3.2.2 2.1 1.3 3.2 3.4 3.4 2.1-.2 3.2-1.3 3.4-3.4z",
    style: {
      fill: "#fff"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M210.3 203.2c-2.4.3-3.8 1.6-4 4 .2 2.5 1.5 3.9 4 4.1 2.4-.3 3.8-1.6 4-4.1-.3-2.4-1.6-3.7-4-4m-2.7 4c.1-1.6 1-2.5 2.6-2.6 1.6.1 2.5 1 2.6 2.6-.1 1.7-1 2.6-2.6 2.8-1.6-.2-2.5-1.2-2.6-2.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M205.4 197c-.2-2.1-1.3-3.2-3.4-3.4-2.1.2-3.2 1.3-3.4 3.4.2 1.9 1.3 3 3.4 3.2 2.1-.2 3.2-1.3 3.4-3.2z",
    style: {
      fill: "#fff"
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M202 192.9c-2.4.3-3.8 1.6-4 4.1.2 2.3 1.5 3.6 4 4 2.4-.3 3.8-1.6 4-4-.2-2.5-1.5-3.8-4-4.1m-2.6 4.1c.1-1.7 1-2.6 2.6-2.8 1.6.2 2.5 1.1 2.6 2.8-.1 1.6-1 2.5-2.6 2.6-1.6 0-2.5-.9-2.6-2.6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M206.8 175c-.2-2-1.3-3.1-3.4-3.2-1.9.1-3 1.2-3.2 3.2.3 2.1 1.3 3.2 3.2 3.4 2.1-.2 3.2-1.4 3.4-3.4z",
    style: {
      fill: "#fff"
    }
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M203.5 171.1c-2.3.3-3.6 1.6-4 4 .3 2.5 1.6 3.9 4 4.1 2.5-.3 3.9-1.6 4.1-4.1-.2-2.4-1.6-3.7-4.1-4m-2.6 4c.3-1.6 1.1-2.5 2.6-2.6 1.7.1 2.6 1 2.8 2.6-.2 1.7-1.1 2.6-2.8 2.8-1.5-.2-2.4-1.2-2.6-2.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M215 159.8c-.2-2.1-1.3-3.2-3.4-3.4-2.1.2-3.2 1.3-3.4 3.4.2 1.9 1.3 3 3.4 3.2 2.1-.1 3.2-1.2 3.4-3.2z",
    style: {
      fill: "#fff"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M211.5 155.8c-2.4.3-3.8 1.6-4 4.1.2 2.4 1.5 3.7 4 4 2.4-.3 3.8-1.6 4-4-.2-2.5-1.5-3.8-4-4.1m-2.6 4.1c.1-1.7 1-2.6 2.6-2.8 1.6.2 2.5 1.1 2.6 2.8-.1 1.5-1 2.4-2.6 2.6-1.6-.2-2.5-1.1-2.6-2.6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M205.1 152.3c-.2-2.1-1.3-3.2-3.4-3.4-2.1.2-3.2 1.3-3.4 3.4.2 2.1 1.3 3.2 3.4 3.4 2.1-.2 3.2-1.3 3.4-3.4z",
    style: {
      fill: "#fff"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M201.8 148.4c-2.4.2-3.8 1.5-4 4 .2 2.4 1.5 3.8 4 4 2.4-.2 3.8-1.5 4-4-.2-2.5-1.5-3.8-4-4m-2.6 4c.1-1.6 1-2.5 2.6-2.6 1.6.1 2.5 1 2.6 2.6-.1 1.6-1 2.5-2.6 2.6-1.6-.1-2.5-1-2.6-2.6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M212.4 128.8c-.2-2.1-1.3-3.2-3.2-3.4-2.1.2-3.2 1.3-3.4 3.4.2 2.1 1.3 3.2 3.4 3.4 2-.2 3.1-1.3 3.2-3.4z",
    style: {
      fill: "#fff"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M209.3 124.8c-2.5.2-3.9 1.5-4.1 4 .3 2.4 1.6 3.8 4.1 4 2.3-.2 3.6-1.5 4-4-.3-2.5-1.6-3.9-4-4m-2.8 3.9c.2-1.6 1.1-2.5 2.8-2.6 1.5.1 2.4 1 2.6 2.6-.3 1.6-1.1 2.5-2.6 2.6-1.7-.1-2.6-1-2.8-2.6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M205.4 217.7c-.2-1.9-1.3-3-3.4-3.2-2.1.2-3.2 1.3-3.4 3.2.2 2.1 1.3 3.2 3.4 3.4 2.1-.2 3.2-1.3 3.4-3.4z",
    style: {
      fill: "#fff"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M202 213.9c-2.4.3-3.8 1.6-4 4 .2 2.5 1.5 3.9 4 4.1 2.4-.3 3.8-1.6 4-4.1-.2-2.4-1.5-3.7-4-4m-2.6 3.9c.1-1.6 1-2.4 2.6-2.6 1.6.2 2.5 1.1 2.6 2.6-.1 1.7-1 2.6-2.6 2.8-1.6-.2-2.5-1.1-2.6-2.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M215 241.3c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7s1.2 6.3 3.6 8.7c2.4 2.4 5.3 3.6 8.7 3.6s6.2-1.2 8.6-3.6c2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    style: {
      fill: "#369",
      fillOpacity: 0.502
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9981 0 0 1 202.467 254.868)",
    style: {
      fontSize: "11.4815px",
      fontFamily: "'ArialMT'",
      fill: "#fff"
    }
  }, "\n    1\n  "), /*#__PURE__*/React.createElement("path", {
    d: "M384 241.3c-2.4-2.4-5.2-3.6-8.6-3.6s-6.3 1.2-8.7 3.6c-2.4 2.4-3.6 5.3-3.6 8.7s1.2 6.3 3.6 8.7c2.4 2.4 5.3 3.6 8.7 3.6 3.4 0 6.2-1.2 8.6-3.6s3.6-5.3 3.6-8.7c0-3.4-1.2-6.3-3.6-8.7z",
    style: {
      fill: "#369",
      fillOpacity: 0.502
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9981 0 0 1 371.518 254.868)",
    style: {
      fontSize: "11.4815px",
      fontFamily: "'ArialMT'",
      fill: "#fff"
    }
  }, "\n    2\n  "), /*#__PURE__*/React.createElement("path", {
    d: "M553.1 241.3c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7s1.2 6.3 3.6 8.7c2.4 2.4 5.3 3.6 8.7 3.6s6.2-1.2 8.6-3.6c2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    style: {
      fill: "#369",
      fillOpacity: 0.502
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9981 0 0 1 540.617 254.868)",
    style: {
      fontSize: "11.4815px",
      fontFamily: "'ArialMT'",
      fill: "#fff"
    }
  }, "\n    3\n  "));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem13A);
export default __webpack_public_path__ + "static/media/item13a.cb5a8d7d3f1ac4b9d36dcf60d3edce02.svg";
export { ForwardRef as ReactComponent };